// import axios from '@/helpers/axios'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

let VueMomentPlugin = {}

// VueAxiosPlugin.install = (Vue, { router, store }) => { // 应用：Vue.use(VueAxiosPlugin, { router, store })
VueMomentPlugin.install = Vue => {
  Vue.prototype.$moment = moment
}

export default VueMomentPlugin
